"use strict";

var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthContext = exports.AuthContext = void 0;
var shared_1 = require("@clerk/shared");
_a = (0, shared_1.createContextAndHook)('AuthContext'), exports.AuthContext = _a[0], exports.useAuthContext = _a[1];